import {
  CURRENCIES,
  LOCALES,
  DEFAULT_COUNTRY,
} from "@pency/constants/catalogs/i18n";

import { i18n } from "next-i18next";

export function formatPrice(
  price: number,
  countryOverride?: string,
  format: "locale" | "iso" = "locale",
  hideDecimals = false
) {
  // If a country is provided directly, use it. Otherwise, try to derive from i18n language.
  let country: string;

  if (countryOverride && CURRENCIES[countryOverride]) {
    country = countryOverride;
  } else {
    const locale = i18n?.language || LOCALES[DEFAULT_COUNTRY];
    const result = Object.entries(LOCALES).find(
      ([, _locale]) => locale === _locale
    );
    country = result?.[0] || DEFAULT_COUNTRY;
  }

  switch (format) {
    case "iso": {
      return `${Number(price).toFixed(hideDecimals ? 0 : 2)} ${
        CURRENCIES[country]
      }`;
    }

    case "locale":
    default: {
      return Number(price).toLocaleString(LOCALES[country], {
        style: "currency",
        currency: CURRENCIES[country],
        // Display only: the price is rounded, the charged amount keeps its decimals
        ...(hideDecimals && {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
      });
    }
  }
}
